import { memo } from 'react';
import PropTypes from 'prop-types';

/**
 * @class
 * @param {string} text Specifies text of Copyright
 *
 * @returns Copyright Component as per the text provided
 */

const Copyright = ({ text }) => <p>{text}</p>;

Copyright.PropTypes = {
  text: PropTypes.string.isRequired
};

export default memo(Copyright);
